export enum PartsUIMessages {
  SEARCH_PARTS_ERROR = 'An error occured while searching parts',
  ACTIVATE_PARTS_CONFIRMATION_TITLE = 'Activate Part(s)',
  ACTIVATE_PARTS_CONFIRMATION = 'Are you sure you want to activate the selected part(s)?',
  ACTIVATE_PARTS_SUCCESS = 'Part(s) successfully activated',
  ACTIVATE_PARTS_ERROR = 'An error occured while activating selected part(s)',
  RETIRE_PARTS_CONFIRMATION_TITLE = 'Retire Part(s)',
  RETIRE_PARTS_CONFIRMATION = 'Are you sure you want to retire the selected part(s)?',
  RETIRE_PARTS_SUCCESS = 'Part(s) successfully retired',
  RETIRE_PARTS_ERROR = 'An error occured while retiring selected part(s)',
  GET_PART_DETAILS_ERROR = 'An error occured while getting part details',
  EXPORT_PARTS_SUCCESS = 'Part(s) exported successfully',
  EXPORT_PARTS_ERROR = 'An error occured while exporting selected part(s)',
  EXPORT_PARTS_CONFIRMATION_TITLE = 'Export Part(s)',
  EXPORT_PARTS_CONFIRMATION = 'Are you sure you want to export the part(s) list?',
  UPDATE_PART_SUCCESS = 'Part updated successfully',
  UPDATE_PART_ERROR = 'An error occured while updating the part',
  UPDATE_PART_CONFIRMATION_TITLE = 'Save Part',
  UPDATE_PART_CONFIRMATION_MESSAGE = 'Are you sure you want to save this part?',
  ADD_PART_SUCCESS = 'Part created successfully',
  ADD_PART_ERROR = 'An error occurred while creating the part',
  ADD_PART_DUPLICATE = 'This part already exists',
  UPDATE_SUPPLIER_PART_SUCCESS = 'Supplier part updated successfully',
  UPDATE_SUPPLIER_PART_ERROR = 'An error occured while updating supplier part',
  UPDATE_LINES_OF_SERVICE_SUCCESS = 'Lines of service updated',
  UPDATE_LINES_OF_SERVICE_ERROR = 'An error occured while updating lines of service',
  UPDATE_CUSTOMER_SUCCESS = 'Customer updated',
  UPDATE_CUSTOMER_ERROR = 'An error occured while updating customer'
}
